import { render, staticRenderFns } from "./hireParkingSpaceList.vue?vue&type=template&id=067b061c&scoped=true"
import script from "./hireParkingSpaceList.vue?vue&type=script&lang=js"
export * from "./hireParkingSpaceList.vue?vue&type=script&lang=js"
import style0 from "./hireParkingSpaceList.vue?vue&type=style&index=0&id=067b061c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067b061c",
  null
  
)

export default component.exports